import Vue from "vue";
import Vuex from "vuex";
import createLogger from "vuex/dist/logger";
import AppModule from "./modules/app.store";
import WelcomeModule from "./modules/welcome.store";
import PaymentModule from "./modules/payment.store";
import CountryModule from "./modules/country.store";
import UserModule from "./modules/user.store";
import PlanModule from "./modules/plans.store";
import AnxietyModule from "./modules/anxiety.store";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  modules: {
    AppModule,
    WelcomeModule,
    PaymentModule,
    CountryModule,
    AnxietyModule,
    UserModule,
    PlanModule,
  },
  strict: debug,
  plugins: debug ? [createLogger()] : [], // Run debug logger on development
});
